import React from 'react';

export default (_props) => {
  const { className, size, large, small, ...props } = _props;

  // small icon
  if ((size && size.toLowerCase() === 'small') || small) {
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" className={`audiicon audiicon-small ${className ? className : ''}`} {...props}>
        <path d="M6.5 3.3L18.5 11.4 6.5 19.7z" stroke="currentColor" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinejoin="round"/>
      </svg>
    );
  }

  // large icon
  return (
    <svg width="48" height="48" viewBox="0 0 48 48" className={`audiicon audiicon-large ${className ? className : ''}`} {...props}>
      <path d="M13.5,9.3 L34.4,23.3 L13.5,37.7 C13.5,37.7 13.5,9.3 13.5,9.3 Z" fillRule="nonzero" stroke="currentColor" strokeWidth="1" fill="none"/>
    </svg>
  );
};
